'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import Calendar from 'components/base/Calendar/Calendar';
import CalendarDay from 'components/base/Calendar/CalendarDay';
import moment from 'moment';
import _ from 'underscore';
import utils from 'services/utils';
import constants from 'constants/appConstants';

import 'styles/CalendarWrapper.scss';


const now = moment();

const propTypes = {
    year: PropTypes.number,
    month: PropTypes.number,
    dayFormatter: PropTypes.func,
    currentDate: PropTypes.object,
};

const defaultProps = {
    year: now.year(),
    month: now.month() + 1,
    dayFormatter: CalendarDay,
};

class CalendarWrapper extends React.Component {

    constructor(props) {
        super(props);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleTodayClick = this.handleTodayClick.bind(this);
        this.handlePrevMonthClick = this.handlePrevMonthClick.bind(this);
        this.handleNextMonthClick = this.handleNextMonthClick.bind(this);
        this.state = {
            months: [moment("{0}-{1}".format(this.props.year, this.props.month), 'YYYY-MM')],
            currentMonthIndex: 0,
            selectedDate: null,
        };
    }  

    componentDidMount() {
        //document.addEventListener("click", this.handleDocumentClick);
    }  

    componentWillUnmount() {
        //document.removeEventListener("click", this.handleDocumentClick);
    } 

    handleDocumentClick(event) {

        utils.preventDefault(event); 
        event.stopPropagation();
        
        if (event.nativeEvent) {
            event.nativeEvent.stopImmediatePropagation();
        }
        return false;
    }

    handlePrevMonthClick(event) {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        //utils.preventDefault(event);

        if (this.state.currentMonthIndex > 0) {
            this.setState({
                currentMonthIndex: this.state.currentMonthIndex - 1,
            });
        } else {
            var months = this.state.months;
            var currentMonth = months[this.state.currentMonthIndex];
            var newMonth = currentMonth.clone().subtract(1, 'month');
            months.unshift(newMonth);
            this.setState({
                months,
            });
        }
    }

    handleNextMonthClick(event) {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        //utils.preventDefault(event);
        if (this.state.currentMonthIndex < this.state.months.length - 1) {
            this.setState({
                currentMonthIndex: this.state.currentMonthIndex + 1,
            });
        } else {
            var months = this.state.months;
            var currentMonth = months[this.state.currentMonthIndex];
            var newMonth = currentMonth.clone().add(1, 'month');
            months.push(newMonth);
            this.setState({
                months,
                currentMonthIndex: this.state.currentMonthIndex + 1,
            });
        }
    }

    handleTodayClick(event) {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        //utils.preventDefault(event);
        this.props.handleDayClickCallback(moment(), null);
    }

    render() {
        var month = this.state.months[this.state.currentMonthIndex];

        return (
            <div className="calendar" onClick={this.handleDocumentClick}>
                <div className="month-header">
                    <button type="button" className="button--plain add-button prev-selector" onClick={this.handlePrevMonthClick}>
                        <i className="arrow-left" />
                    </button>
                    {month.format(constants.dates.formats.FULL_MONTH_YEAR_ONLY)}
                    <button type="button" className="button--plain add-button next-selector" onClick={this.handleNextMonthClick}>
                        <i className="arrow-right" />
                    </button>
                </div>

                <Calendar 
                    handleDayClickCallback={this.props.handleDayClickCallback}
                    month={month}
                    dayFormatter={this.props.dayFormatter}
                    formats={this.props.formats}
                    currentDate={this.props.currentDate}
                />
                <button type="button" className="button  today-button" onClick={this.handleTodayClick}>Today</button>
            </div>
        );
    }
}

CalendarWrapper.propTypes = propTypes;
CalendarWrapper.defaultProps = defaultProps;
export default CalendarWrapper; 